const router = [
  {
    path: '/appointproject',
    meta: {
      title: '预约项目',
      activeMenu: '/appointproject'
    },
    component: () => import('@/views/tourist/appointmanage/project/Project')
  },
  {
    path: '/appointproject/add',
    name: 'appointprojectAdd',
    meta: {
      title: '添加项目',
      activeMenu: '/appointproject'
    },
    component: () => import('@/views/tourist/appointmanage/project/ProjectAdd')
  },
  {
    path: '/appointproject/detail:id',
    name: 'AppointprojectDetail',
    meta: {
      title: '详情',
      activeMenu: '/appointproject'
    },
    component: () => import('@/views/tourist/appointmanage/project/ProjectDetail')
  },
  {
    path: '/appointtourist',
    meta: {
      title: '预约游客',
      activeMenu: '/appointtourist'
    },
    component: () => import('@/views/tourist/appointmanage/tourist/Tourist')
  },
  {
    path: '/scenicspot',
    meta: {
      title: '景观景点'
    },
    component: () => import('@/views/tourist/scenicspot/Scenicspot')
  },
  {
    path: '/scenicspot/add',
    name: 'scenicspotAdd',
    meta: {
      title: '新增',
      activeMenu: '/scenicspot'
    },
    component: () => import('@/views/tourist/scenicspot/ScenicspotAdd')
  },
  {
    path: '/scenicspot/update:sceneryId',
    name: 'scenicspotUpdate',
    meta: {
      title: '编辑',
      activeMenu: '/scenicspot'
    },
    component: () => import('@/views/tourist/scenicspot/ScenicspotAdd')
  },
  {
    path: '/scenicspot/detail:sceneryId',
    name: 'scenicspotDetail',
    meta: {
      title: '详情',
      activeMenu: '/scenicspot'
    },
    component: () => import('@/views/tourist/scenicspot/ScenicspotDetail')
  },
  {
    path: '/inparkservice',
    meta: {
      title: '园内服务'
    },
    component: () => import('@/views/tourist/inparkservice/Inparkservice')
  },
  {
    path: '/inparkservice/add',
    name: 'InparkserviceAdd',
    meta: {
      title: '新增',
      activeMenu: '/inparkservice'
    },
    component: () => import('@/views/tourist/inparkservice/InparkserviceAdd')
  },
  {
    path: '/inparkservice/update:id',
    name: 'InparkserviceUpdate',
    meta: {
      title: '编辑',
      activeMenu: '/inparkservice'
    },
    component: () => import('@/views/tourist/inparkservice/InparkserviceAdd')
  },
  {
    path: '/inparkservice/detail:id',
    name: 'InparkserviceDetail',
    meta: {
      title: '详情',
      activeMenu: '/inparkservice'
    },
    component: () => import('@/views/tourist/inparkservice/InparkserviceDetail')
  },
  {
    path: '/themeactivity',
    meta: {
      title: '主题活动'
    },
    component: () => import('@/views/tourist/themeactivity/Themeactivity')
  },
  {
    path: '/themeactivity/add',
    name: 'ThemeactivityAdd',
    meta: {
      title: '新增',
      activeMenu: '/themeactivity'
    },
    component: () => import('@/views/tourist/themeactivity/ThemeactivityAdd')
  },
  {
    path: '/themeactivity/update:id',
    name: 'ThemeactivityUpdate',
    meta: {
      title: '编辑',
      activeMenu: '/themeactivity'
    },
    component: () => import('@/views/tourist/themeactivity/ThemeactivityAdd')
  },
  {
    path: '/themeactivity/detail:id',
    name: 'ThemeactivityDetail',
    meta: {
      title: '详情',
      activeMenu: '/themeactivity'
    },
    component: () => import('@/views/tourist/themeactivity/ThemeactivityDetail')
  },
  {
    path: '/lostfound',
    meta: {
      title: '失物招领'
    },
    component: () => import('@/views/tourist/lostfound/Lostfound')
  },
  {
    path: '/lostfound/add',
    name: 'LostfoundAdd',
    meta: {
      title: '新增',
      activeMenu: '/lostfound'
    },
    component: () => import('@/views/tourist/lostfound/LostfoundAdd')
  },
  {
    path: '/lostfound/update:id',
    name: 'LostfoundUpdate',
    meta: {
      title: '编辑',
      activeMenu: '/lostfound'
    },
    component: () => import('@/views/tourist/lostfound/LostfoundAdd')
  },
  {
    path: '/customermanage',
    meta: {
      title: '客服管理'
    },
    component: () => import('@/views/tourist/customermanage/CustomerManage')
  },
  {
    path: '/evaluate',
    meta: {
      title: '游客评价'
    },
    component: () => import('@/views/tourist/evaluate/Evaluate')
  },
  {
    path: '/evaluate/detail:id',
    name: 'EvaluateDetail',
    meta: {
      title: '查看评论',
      activeMenu: '/evaluate'
    },
    component: () => import('@/views/tourist/evaluate/EvaluateDetail')
  },
  {
    path: '/questionsurvey',
    meta: {
      title: '问卷调查'
    },
    component: () => import('@/views/tourist/questionsurvey/Questionsurvey')
  },
  {
    path: '/questionsurvey/add',
    name: 'QuestionsurveyAdd',
    meta: {
      title: '新增',
      activeMenu: '/questionsurvey'
    },
    component: () => import('@/views/tourist/questionsurvey/QuestionsurveyAdd')
  },
  {
    path: '/questionsurvey/update:id',
    name: 'QuestionsurveyUpdate',
    meta: {
      title: '编辑',
      activeMenu: '/questionsurvey'
    },
    component: () => import('@/views/tourist/questionsurvey/QuestionsurveyAdd')
  },
  {
    path: '/questionsurvey/detail:id',
    name: 'QuestionsurveyDetail',
    meta: {
      title: '详情',
      activeMenu: '/questionsurvey'
    },
    component: () => import('@/views/tourist/questionsurvey/QuestionsurveyDetail')
  },
  {
    path: '/questionsurvey/details/:id',
    name: 'QuestionsurveyDetail2',
    meta: {
      title: '详情',
      activeMenu: '/questionsurvey'
    },
    component: () => import('@/views/tourist/questionsurvey/QuestionsurveyDetail2')
  },
  {
    path: '/notice',
    meta: {
      title: '公告发布'
    },
    component: () => import('@/views/tourist/notice/Notice')
  },
  {
    path: '/notice/add',
    name: 'NoticeAdd',
    meta: {
      title: '添加公告',
      activeMenu: '/notice'
    },
    component: () => import('@/views/tourist/notice/NoticeAdd')
  },
  {
    path: '/notice/update:id',
    name: 'NoticeUpdate',
    meta: {
      title: '编辑公告',
      activeMenu: '/notice'
    },
    component: () => import('@/views/tourist/notice/NoticeAdd')
  },
  {
    path: '/feedback',
    meta: {
      title: '投诉反馈'
    },
    component: () => import('@/views/tourist/feedback/Feedback')
  },
  {
    path: '/feedback/detail/:feedbackId',
    name: 'FeedbackDetail',
    meta: {
      title: '查看',
      activeMenu: '/feedback'
    },
    component: () => import('@/views/tourist/feedback/FeedbackDetail')
  }
]

export default router
